import React, { useEffect } from "react";

import Aos from "aos";
import { useAllPrismicDocumentsByType } from "@prismicio/react";
import CardSingle from "../Services/Card/CardSingle";
import TextSingle from "../Services/TextCard/TextSingle";
import NormalText from "../Services/NormalText/NormalText";

const items = [
  {
    src: "/mission.png",
    title: "OUR MISSION",
    dataAos: "zoom-out-right",
    desc: "Our mission is to enhancing the business growth of our customers with creative Design and Development to deliver market-defining high-quality solutions that create value and reliable competitive advantage for our clients around the world.",
  },
  {
    src: "/vission.png",
    title: "OUR VISION",
    dataAos: "zoom-out-left",
    desc: "Our vision is to be the most trusted provider of Solutions and Services in Liferay and the open-source technologies known for its value in Technical Expertise, Execution, Capabilities, and Innovation.",
  },
];
const listItems = [
  {
    list: "Clients globally across domains & verticals.",
  },
  {
    list: "Expertise on Liferay leader in open source as per Gartner.",
  },
  {
    list: "Over 60+ globally mobilized consultants available to meet client requirements.",
  },
  {
    list: "CMMI Level 3 rated by our partner company.",
  },
  {
    list: "Global Focus – US, Asia-Pacific & Europe.",
  },
];

const iconpaddingRight = {
  paddingRight: "8px",
};

const ImgWidth = {
  width: "140px",
  height: "auto",
  display: "block",
  marginLeft: "auto",
  marginRight: "auto",
};
const titleColor = {
  color: "white",
  textAlign: "center",
};
const titeleFont = {
  fontSize: "17px",
};
const textFont = {
  fontSize: "13px",
};
const Company = (props: any) => {
  useEffect(() => {
    Aos.init();
    window.scrollTo(0, 0);
  }, []);
  const [document] = useAllPrismicDocumentsByType("aboutus");
  const slice2 = document && document[0]?.data;



  const NormalTextbg = {
    backgroundSize: "cover",
    backgroundPosition: "cover",
    backgroundImage: `url(${
      
        
      slice2 ?slice2?.body[3].primary.bg_img.url:"normaltext.jfif"
    })`,
    backgroundRepeat: " no-repeat",
  };
  const PrismicCardData = slice2?.body[1].items?.map((item: any, i: any) => {
    return (
      <div
        className="col-lg-6 col-md-6 mb-30"
        data-aos={item.textaos[0].text}
        data-aos-duration="1500"
        key={i}
      >
        <CardSingle
          itemClass="courses-item"
          titleSecClass={titleColor}
          image={item.img_vm.url}
          visionicon={ImgWidth}
          title={item.tittle[0].text}
          subtitle={item.desc[0].text}
        />
      </div>
    );
  });

  const NormalCardData = items.map((item: any, index: any) => {
    return (
      <div
        className="col-lg-6 col-md-6 mb-10"
        data-aos={item.dataAos}
        data-aos-duration="1500"
        key={index}
      >
        <CardSingle
          itemClass="courses-item"
          titleSecClass={titleColor}
          image={item.src}
          visionicon={ImgWidth}
          title={item.title}
          subtitle={item.desc}
        />
      </div>
    );
  });
  const PrismicListData = slice2?.body[0]?.items?.map((item: any, i: any) => {
    return (
      <li className="listType" key={i}>
        <i className="fa fa-check-square-o" style={iconpaddingRight}></i>
        {item.list_text[0].text}
      </li>
    );
  });
  const NormalListData = listItems.map((item: any, i: any) => {
    return (
      <li className="listType" key={i}>
        <i className="fa fa-check-square-o" style={iconpaddingRight}></i>
        {item.list}
      </li>
    );
  });
  return (
    <React.Fragment>
      <div
        className="webportal main-home  mt-130 md-mt-60"
        style={{ backgroundColor: "#6f3637" }}
      >
        <div className="partition-bg-wrap">
          <div className="container">
            <div className="row">
              <div className=" col-lg-6 pt-30 md-pl-14">
                <div className="sec-title3  mb-40">
                  <h2
                    className="title white-color mb-16 Heading"
                    data-aos="fade-up"
                    data-aos-delay="50"
                    data-aos-duration="1800"
                    style={{ fontSize: "40px" }}
                  >
                    {slice2
                      ? slice2?.body[0].primary.maintittle[0].text
                      : "WHO WE ARE ?"}
                  </h2>
                  <p
                    className="desc white-color  md-pr-0 sub-text"
                    data-aos="fade-up"
                    data-aos-delay="200"
                    data-aos-duration="3000"
                    style={{
                      fontSize: "15px",
                      lineHeight: " 1.4",
                      textAlign: "justify",
                    }}
                  >
                    {slice2
                      ? slice2?.body[0].primary.text1[0].text
                      : "   Esquare was founded in Silicon Valley of India in the year 2010 with a group of like-minded people and is into Liferay Application Development and other open source technologies including Android, iOS, Phone Gap, Cross-platform Mobile  Applications."}

                    <br />
                    <br />
                    {slice2
                      ? slice2?.body[0].primary.text2[0].text
                      : "Our team of experts has successfully helped enterprises migrate to Open Source technologies across Enterprise Content Management, Portals & Social Collaboration, e-commerce, Business Intelligence and ERP through a proven  Open Source adoption methodology."}
                    <br />
                    <br />
                    {slice2 ? PrismicListData : NormalListData}
                  </p>
                </div>
              </div>
              <div className=" col-lg-6 pt-40 md-pt-0 pl-90 md-pl-20">
                <img
                  src={
                    slice2 ? slice2?.body[0].primary.main_img.url : "/about.png"
                  }
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    verticalAlign: "middle",
                    width: " 375px",
                  }}
                ></img>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="card-ss main-home event-bg pt-50 pb-10 md-pt-30 md-pb-0"
        style={{ background: "#233342" }}
      >
        <div className="container">
          <div className="row">{slice2 ? PrismicCardData : NormalCardData}</div>
        </div>
      </div>
      <div
        className="card-Text main-home event-bg pt-10 pb-0 md-pt-10 md-pb-60 md-pb-20"
        style={{ backgroundColor: "#21759B" }}
      >
        <div className="container">
          <div className="row">
            <div
              className="col-lg-6 pt-20 col-md-6 mb-30  md-pb-70"
              data-aos="fade-right"
              data-aos-duration="1500"
            >
              <TextSingle
                itemClass="courses-item"
                titleTextClass={textFont}
                titleHeadClass={titeleFont}
                title={
                  slice2
                    ? slice2?.body[2].primary.first_tittle[0].text
                    : "WE PROVIDE LEADERSHIP AS A COMPANY AND AS INDIVIDUALS..."
                }
                subtitle={
                  slice2
                    ? slice2?.body[2].primary.first_text[0].text
                    : "A component CMS is a software system which involves managing of components (usually customer content) at the component level instead of whole documents or web pages. Though it can work as a standalone application, most of the time it is a sub-functionality of all the other CMS systems (ECMS, WCMS, MCMS etc.). It can assist with marketing, monitoring costs, customer support, and training purposes."
                }
              />
            </div>
            <div
              className="col-lg-6 pt-20 col-md-6 md-pt-2 md-pb-30"
              data-aos="fade-left"
              data-aos-duration="1500"
            >
              <TextSingle
                itemClass="courses-item"
                titleTextClass={textFont}
                titleHeadClass={titeleFont}
                title={
                  slice2
                    ? slice2?.body[2].primary.second_tittle[0].text
                    : "WE ACT WITH INTEGRITY IN ALL WE DO..."
                }
                subtitle={
                  slice2
                    ? slice2?.body[2].primary.second_text[0].text
                    : "We are each personally accountable for the highest standards of behaviour, including honesty and fairness in all aspects of our work. We fulfil our commitments as responsible citizens and employees. We will consistently treat customers and company resources with the respect they deserve."
                }
              />
            </div>
            <div
              className="col-lg-6 col-md-6 mb-0  "
              data-aos="fade-left"
              data-aos-duration="1500"
            >
              <TextSingle
                titleTextClass={textFont}
                titleHeadClass={titeleFont}
                itemClass="courses-item"
                title={
                  slice2
                    ? slice2?.body[2].primary.third_tittle[0].text
                    : "WE VALUE Esquare PEOPLE..."
                }
                subtitle={
                  slice2
                    ? slice2?.body[2].primary.third_text[0].text
                    : "We treat one another with respect and take pride in the significant contributions that come from the diversity of individuals and ideas. Our continued success requires us to provide the education and development needed to help our people grow. We are committed to openness and trust in all relationships."
                }
              />
            </div>
            <div
              className="col-lg-6  col-md-6 md-pt-20 md-pb-40"
              data-aos="fade-right"
              data-aos-duration="1500"
            >
              <TextSingle
                titleTextClass={textFont}
                titleHeadClass={titeleFont}
                itemClass="courses-item"
                title={
                  slice2
                    ? slice2?.body[2].primary.fourth_tittle[0].text
                    : "WE REGARD OUR Vendors AS ESSENTIAL TEAM MEMBERS..."
                }
                subtitle={
                  slice2
                    ? slice2?.body[2].primary.fourth_text[0].text
                    : "We owe our vendors the same type of respect that we show to our customers. Our vendors deserve fair and equitable treatment, clear agreements and honest feedback on performance. We consider our vendors' needs in conducting all aspects of our business."
                }
              />
            </div>
          </div>
        </div>
      </div>
      <div
        className="noraml-Text main-home event-bg pt-30 pb-10 md-pt-10 md-pb-50"
        style={NormalTextbg}
      >
        <div className="container">
          <div className="row">
            <div
              className="col-lg-11 col-md-11  mb-1"
              data-aos="fade-up"
              data-aos-duration="1500"
            >
              <NormalText
                itemClass="courses-item"
                title={slice2?slice2?.body[3].primary.tittle1[0].text:"WE DELIVER CUSTOMER SATISFACTION..."}
                listClass="display-none"
                portalList="portal-none"
                listtwo="listtwo-none"
                listthree="listthree-none"
                cloudList="cloud-none"
                ecommerce="ecommerce-none"
                subtitle1={
                  slice2 ?slice2?.body[3].primary.text1[0].text:"We are dedicated to satisfying our customers. We believe in respecting our customers, listening to their requests and understanding their expectations. We strive to exceed their expectations in affordability, quality and on-time delivery."
                }
              />
              <div className="md-pt-20">
                <NormalText
                  itemClass="courses-item"
                  title={slice2?slice2?.body[3].primary.tittle2[0].text:"WE TAKE RESPONSIBILITY FOR QUALITY..."}
                  listClass="display-none"
                  portalList="portal-none"
                  listtwo="listtwo-none"
                  listthree="listthree-none"
                  cloudList="cloud-none"
                  ecommerce="ecommerce-none"
                  subtitle1={
                    slice2 ?slice2?.body[3].primary.text2[0].text: "Our products and services will be best in class in terms of value received for money paid. We will deliver excellence, strive for continuous improvement and respond vigorously to change. Each of us is responsible for the quality of whatever we do."
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Company;
